export function onlyDigits(value) {
    return (value || "").replace(/\D/g, "").slice(0, 14);
}

export function formatCpfCnpj(value) {
    const digits = onlyDigits(value);

    if(digits.length <= 11){
        return digits
            .replace(/(\d{3})(\d)/, "$1.$2")
            .replace(/(\d{3})(\d)/, "$1.$2")
            .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    }

    return digits
        .replace(/^(\d{2})(\d)/, "$1.$2")
        .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
        .replace(/\.(\d{3})(\d)/, ".$1/$2")
        .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
}

export function validarCpf(value) {
    const cpf = onlyDigits(value);

    if(cpf.length !== 11 || /^(\d)\1+$/.test(cpf)){
        return false;
    }

    let soma = 0;
    for(let i = 0; i < 9; i++){
        soma += parseInt(cpf.charAt(i), 10) * (10 - i);
    }

    let digito = 11 - (soma % 11);
    if(digito === 10 || digito === 11){
        digito = 0;
    }
    if(digito !== parseInt(cpf.charAt(9), 10)){
        return false;
    }

    soma = 0;
    for(let i = 0; i < 10; i++){
        soma += parseInt(cpf.charAt(i), 10) * (11 - i);
    }

    digito = 11 - (soma % 11);
    if(digito === 10 || digito === 11){
        digito = 0;
    }

    return digito === parseInt(cpf.charAt(10), 10);
}

export function validarCnpj(value) {
    const cnpj = onlyDigits(value);

    if(cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)){
        return false;
    }

    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    const digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;

    for(let i = tamanho; i >= 1; i--){
        soma += parseInt(numeros.charAt(tamanho - i), 10) * pos--;
        if(pos < 2){
            pos = 9;
        }
    }

    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if(resultado !== parseInt(digitos.charAt(0), 10)){
        return false;
    }

    tamanho += 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;

    for(let i = tamanho; i >= 1; i--){
        soma += parseInt(numeros.charAt(tamanho - i), 10) * pos--;
        if(pos < 2){
            pos = 9;
        }
    }

    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    return resultado === parseInt(digitos.charAt(1), 10);
}

export function validarCpfCnpj(value) {
    const digits = onlyDigits(value);
    return digits.length === 11 ? validarCpf(digits) : validarCnpj(digits);
}
